import {
  addDays,
  differenceInMinutes,
  max,
  min,
  parseISO,
  startOfDay,
} from 'date-fns';

export const MINUTES_IN_A_DAY = 1440;

export function getRequestedRestDayTotalMinutes(
  absentFrom: string,
  absentTo: string,
): number {
  const from = parseISO(absentFrom);
  const to = parseISO(absentTo);
  return differenceInMinutes(to, from);
}

export function getRequestedRestDayMinutesForDate(
  absentFrom: string,
  absentTo: string,
  rowDate: Date,
): number {
  const from = parseISO(absentFrom);
  const to = parseISO(absentTo);

  const dayStart = startOfDay(rowDate);
  const dayEnd = addDays(dayStart, 1);

  const intervalStart = max([from, dayStart]);
  const intervalEnd = min([to, dayEnd]);

  if (intervalEnd <= intervalStart) {
    return 0;
  } else {
    return differenceInMinutes(intervalEnd, intervalStart);
  }
}

export function isRequestedRestDayFullDayMinutes(minutes: number): boolean {
  if (minutes === 0) {
    return false;
  } else {
    const minutesInADay = 1440;
    const fullDayMinutes = 1439;

    const mod = ((minutes % minutesInADay) + minutesInADay) % minutesInADay;
    return mod === 0 || mod === fullDayMinutes;
  }
}
